(() => {
  const updateSelectedColorLabels = () => {
    document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
      const checked = picker.querySelector('input[type="radio"][name="Color"]:checked');
      const label = picker.querySelector('[data-selected-color]');

      if (checked && label) {
        label.textContent = checked.value;
      }
    });
  };

  document.addEventListener('DOMContentLoaded', updateSelectedColorLabels);
  document.addEventListener('change', updateSelectedColorLabels, true);
  document.addEventListener('click', () => {
    requestAnimationFrame(updateSelectedColorLabels);
  }, true);
  document.addEventListener('shopify:section:load', updateSelectedColorLabels);
})();